import React, { useRef, useEffect } from 'react'
import { GoogleReCaptchaProvider, GoogleReCaptcha } from 'react-google-recaptcha-v3'

const Contact = (props) => {
  const buttonRef = useRef(null)
  const emailRef  = useRef(null)
  useEffect(() => {
    const node              = emailRef.current
    const { contact, tail } = node.dataset
    const address           = `${atob(contact)}@${atob(tail)}`
    node.setAttribute('href', `mailto:${address}`)
    node.innerText = address
  })
  return (
    <section id="contact">
      <div className="inner">
        <section>
          <form method="post" action="https://getform.io/f/f075ad94-a604-4892-aaaa-fe3e3d6b118a">
            <div className="field half first">
              <label htmlFor="name">Name</label>
              <input required type="text" name="name" id="name"/>
            </div>
            <div className="field half">
              <label htmlFor="email">Email</label>
              <input required type="text" name="email" id="email"/>
            </div>
            <div className="field">
              <label htmlFor="message">Message</label>
              <textarea required name="message" id="message" rows="6"></textarea>
            </div>
            <ul className="actions">
              <li><input ref={buttonRef} type="submit" value="Send Message" disabled className="special"/></li>
              <li><input type="reset" value="Clear"/></li>
            </ul>
            <GoogleReCaptchaProvider reCaptchaKey={`6LfFdPEUAAAAAAVtTyB4mb5hZ2UiSrmE3Zbe-nJl`}>
              <GoogleReCaptcha onVerify={token => {
                buttonRef.current.removeAttribute('disabled')
              }}/>
            </GoogleReCaptchaProvider>
          </form>
        </section>
        <section className="split">
          <section>
            <div className="contact-method">
              <span className="icon alt fa-envelope"></span>
              <h3>Email</h3>
              <a ref={emailRef}
                 href="/"
                 data-contact="Z3VudGFycy5zaW1hbnNraXM="
                 data-tail="Z21haWwuY29t"
              >
              </a>
            </div>
          </section>
          <section>
            <div className="contact-method">
              <span className="icon alt fa-phone"></span>
              <h3>Phone: <span style={{fontWeight:200}}>(+353) 87 7495427</span></h3>

            </div>
          </section>

        </section>
      </div>
    </section>
  )
}

export default Contact
